export const LINK = "http://109.120.219.237:4201/api/"
export const HEADERS = { 'content-type': 'application/json' }  
